export const CloseOpenFiltersOnBodyClick = () => {
    document.body.addEventListener("click", (event) => {
        const filters = document.querySelectorAll(".attrax-post-filters");
        filters.forEach((filter) => {
            const heading =
                filter.querySelector<HTMLDivElement>(".filter-open");
            const list = filter.querySelector<HTMLDivElement>(
                ".attrax-post-filters__list"
            );

            if (!heading || !list) return;

            const target = event.target as HTMLElement;

            if (!heading.contains(target) && !list.contains(target)) {
                heading.classList.remove("filter-open");
                list.style.display = "none";
            }
        });
    });
};
